import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { catchError, Observable, switchMap, throwError } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable({
    providedIn: 'root'
})
export class HttpInterceptorService {
    user_key = environment.CHAT_USER_KEY
    private appId = environment.App_id;
    constructor(private authService: AuthService) { }


    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        try {
            // if (req.url.includes('chat') || req?.url?.includes("ngrok-free.app")) {
            let X_Auth_Token = localStorage.getItem(environment.X_Auth_Token);
            let ___token = '';
            if (X_Auth_Token?.trim()) {
                ___token = X_Auth_Token?.replace(/"/g, '');
            }
            const modifiedReq = req.clone({
                setHeaders: {
                    'Authorization': `Bearer ${___token}`,
                    'App-Id': this.appId,
                    'ngrok-skip-browser-warning': 'true',
                }

            });

            //for app_id
            if (!modifiedReq.headers?.has('App-Id')) {
                modifiedReq.headers?.set('App-Id', environment.App_id);
            }
            if (!modifiedReq.headers?.has('App-Id')) {
                modifiedReq.headers?.append('App-Id', environment.App_id);
            }

            return next.handle(modifiedReq).pipe(
                catchError((error: HttpErrorResponse) => this.handleError(error, req, next))
            );
            // }
            // return next.handle(req);
        } catch (error) {
            console.log('HttpInterceptorService intercept catch error', error);
            return next.handle(req);
        }
    }


    private handleError(error: HttpErrorResponse, req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (error.status === 401) {
            if (this.authService.isRefreshing()) {
                console.log('HttpInterceptorService Waiting for token refresh...req', req);
                return this.authService.waitForToken().pipe(
                    switchMap((newToken: any) => {
                        console.log('HttpInterceptorService waitForToken refreshed: newToken', newToken);
                        const retryReq = req.clone({
                            setHeaders: {
                                'Authorization': `Bearer ${newToken?.authToken}`
                            }
                        });
                        return next.handle(retryReq);
                    })
                );
            }
            else {
                this.authService.startTokenRefresh();
                let refreshToken = localStorage?.getItem(environment.X_Refresh_Token)
                console.log('HttpInterceptorService Unauthorized: Refreshing token...',);
                return this.authService.refreshChatToken(refreshToken).pipe(
                    switchMap((tokenData: any) => {
                        const tokenUser = tokenData?.data;
                        console.log('HttpInterceptorService Token refreshed: tokenData', tokenData);
                        if (!tokenData?.success && tokenData?.failedToRefresh) {
                            if (localStorage?.getItem(this.user_key)) {
                                this.authService.logout();
                            }
                        }
                        if (tokenUser?.authToken) {
                            localStorage.setItem(this.user_key, JSON.stringify(tokenUser));
                            localStorage.setItem('X-Auth-Token', tokenUser.authToken);
                            localStorage.setItem('X-User-Id', '' + tokenUser.userId);
                        }
                        this.authService.completeTokenRefresh(tokenUser);

                        // Retry the original request
                        const retryReq = req.clone({
                            setHeaders: {
                                'Authorization': `Bearer ${tokenUser?.authToken}`,
                                'App-Id': this.appId,
                                'ngrok-skip-browser-warning': 'true',
                            }
                        });
                        //for app_id
                        if (!retryReq.headers?.has('App-Id')) {
                            retryReq.headers?.set('App-Id', environment.App_id);
                        }
                        if (!retryReq.headers?.has('App-Id')) {
                            retryReq.headers?.append('App-Id', environment.App_id);
                        }
                        return next.handle(retryReq);
                    }),
                    catchError(err => {
                        if (!err?.success && err?.failedToRefresh ||
                            (err?.error && err?.error.statusCode === 404)
                        ) {
                            this.authService.logout();
                        }
                        console.log('Token refresh failed: err', environment);
                        this.authService.failTokenRefresh();
                        return throwError(err);
                    })
                );
            }
        }

        return throwError(error);
    }
}
